export default __webpack_public_path__ + "static/media/favicon.a35fb3f3.ico";